module.exports = __webpack_public_path__ + "static/media/Inter-roman.var.4b3800cd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-roman.var.woff2
// module id = 712
// module chunks = 21